const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoShort3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    id: "svg_5",
    "data-name": "svg 5",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    "data-name": "svg 1",
    d: "M25.5,4.5A20.77,20.77,0,0,0,5,25.5a20.77,20.77,0,0,0,20.5,21A20.77,20.77,0,0,0,46,25.5,20.77,20.77,0,0,0,25.5,4.5Zm-3,20a45.69,45.69,0,0,1-2.74,12.13A1.87,1.87,0,0,0,20.82,39a1.8,1.8,0,0,0,2.34-1.08,50.77,50.77,0,0,0,2.34-8.5,50.77,50.77,0,0,0,2.34,8.5A1.8,1.8,0,0,0,30.18,39a1.87,1.87,0,0,0,1.06-2.39A45.69,45.69,0,0,1,28.5,24.46a57.54,57.54,0,0,0,6.51-.7,1.86,1.86,0,0,0,1.5-2.13,1.82,1.82,0,0,0-2.08-1.54,55.29,55.29,0,0,1-17.88,0,1.82,1.82,0,0,0-2.07,1.55A1.86,1.86,0,0,0,16,23.76a59.9,59.9,0,0,0,6.51.69Zm3-11.89a3.35,3.35,0,1,1-3.27,3.35A3.31,3.31,0,0,1,25.5,12.57Z",
    style: {
      fill: "#5b5eff",
      fillRule: "evenodd"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoShort3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-short-3.bd1595cbfaf1559154ae0b30ac791930.svg";